// ReferrersTab.tsx
import React from "react";
import { ReferrerEarnings, ColorTheme } from "../types/revenue.types";
import { ReferrerEarningsCard } from "../cards/ReferrerEarningsCard";
import RevenueService from "../../../services/revenueService";

interface ReferrersTabProps {
  referrerEarnings: ReferrerEarnings[];
  colorTheme: ColorTheme;
}

export const ReferrersTab: React.FC<ReferrersTabProps> = ({
  referrerEarnings,
  colorTheme,
}) => {
  const totalEarnings = referrerEarnings.reduce(
    (sum, r) => sum + r.total_earned,
    0,
  );

  return (
    <div>
      {/* Summary Header */}
      <div
        style={{
          background: "white",
          padding: "24px",
          borderRadius: "12px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: colorTheme.gray900,
                marginBottom: "4px",
              }}
            >
              🤝 Referrer Earnings
            </h2>
            <p style={{ fontSize: "14px", color: colorTheme.gray600 }}>
              {referrerEarnings.length} referrers
            </p>
          </div>
          <div
            style={{ fontSize: "24px", fontWeight: "700", color: "#8b5cf6" }}
          >
            {RevenueService.formatCurrency(totalEarnings)}
          </div>
        </div>
      </div>

      {/* Referrer Cards */}
      {referrerEarnings.map((referrer) => (
        <ReferrerEarningsCard
          key={referrer.referrer_id}
          referrer={referrer}
          colorTheme={colorTheme}
        />
      ))}

      {referrerEarnings.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: colorTheme.gray500,
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>🤝</div>
          <p>No referrer earnings found for the selected period.</p>
        </div>
      )}
    </div>
  );
};
